import React, { useEffect, useState } from 'react';
import NewHereLanding from './NewHereLanding';
import squareService from '../../services/squareService';

const titleCase = (s) => (s || '').replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()).trim();

/**
 * NewHereCity — the logged-out City Portal. Shows the NewHereLanding for a city:
 * the header names the city (from the slug immediately), and a backend call fills
 * in a signal calling out a real popular local venue (generated + cached per city
 * on first visit). Falls back to the design's defaults if the call isn't ready.
 */
export default function NewHereCity({ citySlug }) {
  const derivedCity = titleCase(citySlug) || 'Your Town';
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (!citySlug) return undefined;
    let done = false;
    squareService.getNewHere(citySlug)
      .then((r) => { if (!done && r?.success && r.data) setContent(r.data); })
      .catch(() => {});
    return () => { done = true; };
  }, [citySlug]);

  return (
    <NewHereLanding
      city={content?.city || derivedCity}
      signalName={content?.signalName}
      signalMeta={content?.signalMeta}
      signalText={content?.signalText}
    />
  );
}
